export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.proofing_goods_label_goodsQty') || '样品数量',
    field: 'goosQty',
    width: 120,
    fixed: 'left',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsNo') || '产品编号',
    field: 'orderGoodsNo',
    width: 150,
    align: 'center',
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_identifyGoodsNo') || '产品识别编号',
    field: 'identifyGoodsNo',
    width: 230,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.order_goods_label_orderGoodsName') || '产品名称',
    field: 'orderGoodsDisplayName',
    minWidth: 450,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
